<!--
 * @Author: zhangyuan zhangyuan@cheyipai.com
 * @Date: 2022-11-16 14:31:28
 * @LastEditors: zhangyuan zhangyuan@cheyipai.com
 * @LastEditTime: 2022-12-07 10:21:38
 * @FilePath: /report-template/src/views/reportConfirm/components/carInfo.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="reportComfirm_title">
        <span class="reportComfirm_title_tittxt">{{titleTxt}}<b v-if='picNum'> (已上传{{picNum}}张)</b></span>
        <span class="reportComfirm_title_titArrow" @click='goPage' v-if='isShowRight'>去修改
            <van-icon name="arrow" />
        </span>
    </div>
</template>
<script>
import { defineComponent } from 'vue'
import { Icon } from 'scvant';
import plugin from '@/util/plugin.js';

export default defineComponent({
    name: 'reportComfirmTitle',
    props: {
        titleTxt: {
            type: String,
            default: () => {
                return ''
            }
        },
        goPageType: {
            type: String,
            default: () => {
                return ''
            }
        },
        isShowRight: {
            type: Boolean,
            default: () => {
                return true
            }
        },
        picNum: {
            type: Number,
            default: () => {
                return 0
            }
        }
    },
    components: {
        [Icon.name]: Icon,
    },
    // setup() {
        
    // },
    methods: {
        goPage() {
            // 
            let param = {
                methodName: 'goToModify',
                data: {
                    type: this.goPageType
                }
            }
            plugin.appFunHandler(param);
        }
    }
})
</script>

<style scoped lang='less'>
    .reportComfirm_title {
        display: flex;
        justify-content: space-between;
        .reportComfirm_title_tittxt {
            font-size: .18rem;
            line-height: .18rem;
            color: #131212;
            font-weight: 500;
            display: flex;
            align-items: center;
            b {
                font-size: .12rem;
                font-weight: normal;
                padding-left: .1rem;
            }
        }
        .reportComfirm_title_titArrow {
            font-size: .13rem;
            color: #FF4B0A;
        }
    }
</style>